import {Helper} from "../../../../../containers/AppPage/Reports/Ledger/helper";
import {CustomFieldHelper} from "../../../../../shared/CustomFieldHelper";
import { t } from "@lingui/macro";

export function getColumns(props, fields) {
    const { currencySymbol, companyCurrencyCode } = props;
    return [
        {
            key: "date",
            dataKey: "date",
            title: t`Date`,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderDate,
        },
        {
            key: "number",
            dataKey: "number",
            title: t`No.`,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderNumber,
        },
        {
            key: "contact_name",
            dataKey: "contact_name",
            title: t`Contact`,
            width: 0,
            flexGrow: 16,
            cellRenderer: Helper.renderContact,
        },
        {
            title: t`Contact Code`,
            dataIndex: "contact_code",
            key: "contact_code",
            sorter: true,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderContactCode,
        },
        {
            key: "number2",
            dataKey: "number2",
            title: t`Reference No.`,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderNumber2,
        },
        {
            key: "payment_methods",
            dataKey: "payment_methods",
            title: t`Payment Method`,
            width: 0,
            flexGrow: 16,
            cellRenderer: Helper.renderPaymentMethods,
        },
        {
            key: "description",
            dataKey: "description",
            title: t`Description`,
            width: 0,
            flexGrow: 23,
            cellRenderer: Helper.renderDescription,
        },
        {
            key: "amount",
            dataKey: "amount",
            title: t`Amt`,
            align: "right",
            width: 80,
            flexGrow: 12,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.amount, rowData.currency_symbol),
        },
        {
            key: "base_amount",
            dataKey: "base_amount",
            title: companyCurrencyCode ? t`Amt ${companyCurrencyCode}` : t`Home Amt`,
            align: "right",
            width: 70,
            flexGrow: 10,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.base_amount, currencySymbol),
        },
        {
            key: "created_at",
            dataKey: "created_at",
            title: t`Created`,
            width: 0,
            flexGrow: 25,
            cellRenderer: Helper.renderCreatedAt,
        },

        // custom fields
        ...CustomFieldHelper.getColumnsBaseTable(fields.transaction),
    ];
}
